import { Component, OnInit, Inject } from "@angular/core";
import { Router, ActivatedRoute, NavigationEnd } from "@angular/router";
import { filter } from "rxjs/operators";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { EditNrbesComponent } from "../edit-nrbes/edit-nrbes.component";
import { AddNrbesComponent } from "../add-nrbes/add-nrbes.component";
import { WebStorageService, LOCAL_STORAGE } from "ngx-webstorage-service";
import { UserRoleEnum, UserRoleUserOperation } from "../core/constant";
import { environment } from "../../environments/environment";
import { CryptographyService } from "../services/cryptography.service";
import { StandardService } from "../services/standard.service";
import { FilterList } from "../models/filterList";
import { UsefulLinkList } from "../models/usefullink-list";
import { UsefulLink } from "../models/usefullink";
import { AdminService } from "../services/admin.service";
import { FailModuleComponent } from "../fail-module/fail-module.component";

declare var $: any;
@Component({
  selector: "app-left-nav",
  templateUrl: "./left-nav.component.html",
  styleUrls: ["./left-nav.component.scss"],
})
export class LeftNavComponent implements OnInit {
  items = ["Item 1", "Item 2", "Item 3", "Item 4", "Item 5"];
  expandedIndex = 0;
  isAccordionExpanded = localStorage.getItem("accordionState") === "true";
  lastSelectedMenu: string = "";

  expandedAccordion: string | null;
  viewAllAddendum: boolean;
  viewAllGrsStandard: boolean;
  viewAllNotification: boolean;
  viewAllNrbesStandard: boolean;
  viewFaq: boolean;
  viewKeyContacts: boolean;
  showLocation: boolean;
  canAddNewNrbes: boolean;
  canAddNewGrs: boolean;
  showAddNewEquipment: boolean;
  showBuildingCapacityTool: boolean;
  viewFutureStandard: boolean;
  canAddEquipmentStandard: boolean;
  canEditEquipmentStandard: boolean;
  canDeleteEquipmentStandard: boolean;
  viewEquipmentGlobalStandard: boolean;
  viewEquipmentNationalStandard: boolean;
  viewOperationsStandard: boolean;
  viewEquipmentObsoleteStandard: boolean;
  viewUpcomingStandard: boolean;
  CanAddNationalEquipmentStandard: boolean;
  viewGlobalAdminPanel: boolean;
  viewMarketAdminPanel: boolean;
  viewManageSuppliers: boolean;
  viewAllSuppliers: boolean;
  viewAllEquipmentType: boolean;
  viewAllCategory: boolean;
  viewAllUser: boolean;
  viewAllUsefulLinks: boolean;
  viewAllSharedLearningsBestPractices: boolean;
  canAddABUStandards: boolean;
  canEditABUStandard: boolean;
  viewABUStandard: boolean;
  //viewAllGlobalRecomendations: boolean;
  usefulLinkList: UsefulLinkList = new UsefulLinkList();

  previousRoute: string;
  constructor(
    private route: Router,
    @Inject(LOCAL_STORAGE)
    public storage: WebStorageService,
    public standardService: StandardService,
    private cryptographyService: CryptographyService,
    private activeRoute: ActivatedRoute,
    private adminService: AdminService,
    private ngbModal: NgbModal,
  ) { }
  userRole: number;
  get userRoleEnum() {
    return UserRoleEnum;
  }

  getEffectiveUserRole(): number {
    if (
      sessionStorage.getItem("impersonationView") === "true" &&
      sessionStorage.getItem("userRoleId")
    ) {
      return this.cryptographyService.decryptData(
        sessionStorage.getItem("userRoleId"),
      );
    }
    return this.userRole;
  }

  showExceptionsNav(): boolean {
    if (this.getEffectiveUserRole() === UserRoleEnum.BasicUser) {
      return false;
    }
    return this.viewAllAddendum || this.viewAllNotification;
  }

  toggleAccordion(accordionName: string) {
    if (this.expandedAccordion === accordionName) {
      this.expandedAccordion = null;
    } else {
      this.expandedAccordion = accordionName;
    }

    localStorage.setItem("expandedAccordion", this.expandedAccordion || "");
  }

  navigateMenu(route: string, currentMenu: string) {
    if (route.includes("add")) {

      localStorage.setItem("lastSelectedMenu", currentMenu);
    } else if (route == "" && currentMenu == "global-admin-panel") {
      localStorage.setItem("lastSelectedMenu", currentMenu);
    } else {
      localStorage.setItem("lastSelectedMenu", currentMenu);

      this.resetFilteration(route);
    }
  }

  goToHome() {
    localStorage.removeItem("expandedAccordion");
    localStorage.removeItem("lastSelectedMenu");
    this.expandedAccordion = null;
    this.lastSelectedMenu = "";

    this.resetFilteration("/locations");
  }

  /**
   * Maps a route prefix to the menu key used by [class.active]="lastSelectedMenu === '...'"
   * throughout the template. Longest/most specific prefixes first, since matching is
   * "does the current url start with this" and a short prefix could otherwise shadow a
   * more specific one (e.g. a future "/view-all-standards-export" shouldn't match before
   * "/view-all-standards" itself gets a chance).
   *
   * navigateMenu() keeps this in sync for clicks on the nav itself, but any navigation that
   * happens another way - a "Save" button redirecting to a list page, browser back/forward,
   * a deep link - never went through navigateMenu(), so lastSelectedMenu could point at
   * whatever menu item was last clicked instead of the page actually being shown. This map
   * lets the component correct itself from the real current route instead.
   */
  private readonly routeMenuMap: { route: string; menu: string; accordion: string }[] = [
    { route: "/minimum-standard-detail-view", menu: "View All Standards", accordion: "standards" },
    { route: "/operations-standards-detail-view", menu: "View All Standards", accordion: "standards" },
    { route: "/global-recommendations", menu: "View All Standards", accordion: "standards" },
    { route: "/equipment-standard-detail-view", menu: "View All Standards", accordion: "standards" },
    { route: "/view-all-standards", menu: "View All Standards", accordion: "standards" },
    { route: "/view-all-upcoming-standards-list", menu: "View All Upcoming Standards", accordion: "standards" },
    { route: "/add-grs", menu: "add-grs", accordion: "standards" },
    { route: "/add-eq-standards-global", menu: "add-eq-standards-global", accordion: "marketStandards" },
    { route: "/add-abustandard", menu: "add-abustandard", accordion: "marketStandards" },
    { route: "/view-all-equipments", menu: "view-all-equipments", accordion: "marketStandards" },
    { route: "/view-all-obsolete-standards-list", menu: "View All Obsolete Equipment", accordion: "marketStandards" },
    { route: "/market-admin-panel", menu: "market-admin-panel", accordion: "marketStandards" },
    { route: "/addendum-list", menu: "addendum-list", accordion: "exceptionGovernance" },
    // Equipment exceptions land here (e.g. the "View" button after adding/
    // updating an equipment exception) - same "Exceptions" nav item as the
    // non-equipment addendum list, since the equipment-specific link is
    // currently commented out in the template.
    { route: "/equipment-addendum-list", menu: "addendum-list", accordion: "exceptionGovernance" },
    { route: "/notification-list", menu: "notification-list", accordion: "exceptionGovernance" },
    { route: "/view-as-different-role", menu: "view-as-different-role", accordion: "admin" },
    { route: "/view-all-supplier-list", menu: "view-all-supplier-list", accordion: "admin" },
    { route: "/view-all-category-list", menu: "view-all-category-list", accordion: "admin" },
    { route: "/view-all-equipment-type-list", menu: "view-all-equipment-type-list", accordion: "admin" },
    { route: "/view-all-user-list", menu: "view-all-user-list", accordion: "admin" },
    { route: "/view-all-useful-links", menu: "view-all-useful-links", accordion: "admin" },
    { route: "/update-application-statement", menu: "update-application-statement", accordion: "admin" },
    { route: "/run/view-script", menu: "run/view-script", accordion: "admin" },
    { route: "/keycontact", menu: "keycontact", accordion: "toolInformation" },
    { route: "/faq", menu: "faq", accordion: "toolInformation" },
  ];

  /** Finds the route-menu-map entry this url actually belongs to, or null if it isn't a route the left-nav tracks. */
  private resolveEntryForUrl(url: string): { route: string; menu: string; accordion: string } | null {
    return this.routeMenuMap.find((entry) => url.startsWith(entry.route)) ?? null;
  }

  /** Corrects lastSelectedMenu AND expandedAccordion from the real current route, so neither
   *  can go stale after a non-click navigation (e.g. a save/submit redirect) - otherwise the
   *  right item could highlight while sitting inside a collapsed, still-wrong-looking section. */
  private syncActiveMenuWithRoute(url: string): void {
    // Home ("/locations") has no entry in routeMenuMap - it's highlighted via
    // routerLinkActive instead. goToHome() clears the rest of the nav's selection
    // state on a click; landing here via a direct URL/back-button navigation needs
    // the same reset, or a previously-selected item (and its expanded accordion)
    // keeps showing active alongside Home.
    if (url === "/" || url.startsWith("/locations")) {
      if (this.lastSelectedMenu) {
        this.lastSelectedMenu = "";
        localStorage.removeItem("lastSelectedMenu");
      }
      if (this.expandedAccordion) {
        this.expandedAccordion = null;
        localStorage.removeItem("expandedAccordion");
      }
      return;
    }

    const resolvedEntry = this.resolveEntryForUrl(url);
    if (!resolvedEntry) {
      return;
    }
    if (resolvedEntry.menu !== this.lastSelectedMenu) {
      this.lastSelectedMenu = resolvedEntry.menu;
      localStorage.setItem("lastSelectedMenu", resolvedEntry.menu);
    }
    if (resolvedEntry.accordion !== this.expandedAccordion) {
      this.expandedAccordion = resolvedEntry.accordion;
      localStorage.setItem("expandedAccordion", resolvedEntry.accordion);
    }
  }

  ngOnInit(): void {
    this.expandedAccordion = localStorage.getItem("expandedAccordion");
    this.lastSelectedMenu = localStorage.getItem("lastSelectedMenu");
    this.syncActiveMenuWithRoute(this.route.url);
    this.route.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.syncActiveMenuWithRoute(event.urlAfterRedirects);
      });
    this.userRole = this.storage.get("userRole")
      ? this.cryptographyService.decryptData(this.storage.get("userRole"))
      : this.storage.get("userRole");
    this.getUsefulLinks();
    //userRoleUserOperation
    if (!environment.skipAuthentication) {
      let userRoleUserOperation = this.storage.get("userRoleUserOperation")
        ? this.cryptographyService.decryptData(
          this.storage.get("userRoleUserOperation"),
        )
        : this.storage.get("userRoleUserOperation");

      if (userRoleUserOperation) {
        this.viewAllAddendum =
          userRoleUserOperation.indexOf(
            UserRoleUserOperation.ViewAllAddendum,
          ) !== -1;
        this.viewAllGrsStandard =
          userRoleUserOperation.indexOf(
            UserRoleUserOperation.ViewAllGrsStandard,
          ) !== -1;
        //this.viewAllGlobalRecomendations = (userRoleUserOperation.indexOf(UserRoleUserOperation.ViewAllGrsStandard) !== -1);
        this.viewAllNotification =
          userRoleUserOperation.indexOf(
            UserRoleUserOperation.ViewAllNotification,
          ) !== -1;
        this.viewAllNrbesStandard =
          userRoleUserOperation.indexOf(
            UserRoleUserOperation.ViewAllNrbesStandard,
          ) !== -1;
        this.viewFaq =
          userRoleUserOperation.indexOf(UserRoleUserOperation.ViewFaq) !== -1;
        this.viewKeyContacts =
          userRoleUserOperation.indexOf(
            UserRoleUserOperation.ViewKeyContacts,
          ) !== -1;
        this.showLocation =
          userRoleUserOperation.indexOf(UserRoleUserOperation.ShowLocation) !==
          -1;
        this.canAddNewNrbes = false;
        this.canAddNewGrs =
          userRoleUserOperation.indexOf(UserRoleUserOperation.CanAddNewGrs) !==
          -1;
        this.showAddNewEquipment =
          userRoleUserOperation.indexOf(
            UserRoleUserOperation.ShowAddNewEquipment,
          ) !== -1;
        this.showBuildingCapacityTool =
          userRoleUserOperation.indexOf(
            UserRoleUserOperation.ShowBuildingCapacityTool,
          ) !== -1;
        this.viewFutureStandard =
          userRoleUserOperation.indexOf(
            UserRoleUserOperation.ViewFutureStandard,
          ) !== -1;

        this.canAddEquipmentStandard =
          userRoleUserOperation.indexOf(
            UserRoleUserOperation.CanAddEquipmentStandard,
          ) !== -1;
        this.CanAddNationalEquipmentStandard =
          userRoleUserOperation.indexOf(
            UserRoleUserOperation.CanAddNationalEquipmentStandard,
          ) !== -1;
        this.canEditEquipmentStandard =
          userRoleUserOperation.indexOf(
            UserRoleUserOperation.CanEditEquipmentStandard,
          ) !== -1;
        this.canDeleteEquipmentStandard =
          userRoleUserOperation.indexOf(
            UserRoleUserOperation.CanDeleteEquipmentStandard,
          ) !== -1;
        this.viewEquipmentGlobalStandard =
          userRoleUserOperation.indexOf(
            UserRoleUserOperation.ViewEquipmentGlobalStandard,
          ) !== -1;
        this.viewEquipmentNationalStandard =
          userRoleUserOperation.indexOf(
            UserRoleUserOperation.ViewEquipmentNationalStandard,
          ) !== -1;
        this.viewEquipmentObsoleteStandard =
          userRoleUserOperation.indexOf(
            UserRoleUserOperation.ViewEquipmentObsoleteStandard,
          ) !== -1;
        this.viewUpcomingStandard =
          userRoleUserOperation.indexOf(
            UserRoleUserOperation.ViewUpcomingStandard,
          ) !== -1;
        this.viewGlobalAdminPanel =
          userRoleUserOperation.indexOf(
            UserRoleUserOperation.ViewGlobalAdminPanel,
          ) !== -1;
        this.viewMarketAdminPanel =
          userRoleUserOperation.indexOf(
            UserRoleUserOperation.ViewMarketAdminPanel,
          ) !== -1;
        this.viewManageSuppliers =
          userRoleUserOperation.indexOf(
            UserRoleUserOperation.ViewManageSuppliers,
          ) !== -1;
        this.viewAllSuppliers =
          userRoleUserOperation.indexOf(
            UserRoleUserOperation.ViewAllSuppliers,
          ) !== -1;
        this.viewAllEquipmentType =
          userRoleUserOperation.indexOf(
            UserRoleUserOperation.ViewAllEquipmentType,
          ) !== -1;
        this.viewAllCategory =
          userRoleUserOperation.indexOf(
            UserRoleUserOperation.ViewAllCategory,
          ) !== -1;
        this.viewAllUser =
          userRoleUserOperation.indexOf(UserRoleUserOperation.ViewAllUser) !==
          -1;
        this.viewAllUsefulLinks =
          userRoleUserOperation.indexOf(
            UserRoleUserOperation.ViewAllUsefulLinks,
          ) !== -1;
        this.viewAllSharedLearningsBestPractices =
          userRoleUserOperation.indexOf(
            UserRoleUserOperation.ViewAllSharedLearningsBestPractices,
          ) !== -1;
        this.canAddABUStandards =
          userRoleUserOperation.indexOf(
            UserRoleUserOperation.CanAddABUStandard,
          ) !== -1;
        this.canEditABUStandard =
          userRoleUserOperation.indexOf(
            UserRoleUserOperation.CanEditABUStandard,
          ) !== -1;
        this.viewABUStandard =
          userRoleUserOperation.indexOf(
            UserRoleUserOperation.ViewABUStandard,
          ) !== -1;
        this.viewOperationsStandard =
          userRoleUserOperation.indexOf(
            UserRoleUserOperation.ViewOperationsStandard,
          ) !== -1;
      }
    } else {
      this.viewAllAddendum = true;
      this.viewAllGrsStandard = true;
      //this.viewAllGlobalRecomendations = true;
      this.viewAllNotification = true;
      this.viewAllNrbesStandard = true;
      this.viewFaq = true;
      this.viewKeyContacts = true;
      this.showLocation = true;
      this.canAddNewNrbes = false;
      this.canAddNewGrs = true;
      this.showAddNewEquipment = true;
      this.showBuildingCapacityTool = true;
      this.viewFutureStandard = true;
      this.canAddEquipmentStandard = true;
      this.CanAddNationalEquipmentStandard = true;
      this.canEditEquipmentStandard = true;
      this.canDeleteEquipmentStandard = true;
      this.viewEquipmentGlobalStandard = true;
      this.viewEquipmentNationalStandard = true;
      this.viewEquipmentObsoleteStandard = true;
      this.viewUpcomingStandard = true;
      this.viewGlobalAdminPanel = true;
      this.viewMarketAdminPanel = true;
      this.viewManageSuppliers = true;
      this.viewAllSuppliers = true;
      this.viewAllEquipmentType = true;
      this.viewAllCategory = true;
      this.viewAllUser = true;
      this.viewAllUsefulLinks = true;
      this.viewAllSharedLearningsBestPractices = true;
      this.canAddABUStandards = true;
      this.canEditABUStandard = true;
      this.viewABUStandard = true;
      this.viewOperationsStandard = true;
    }

    $(document).ready(() => {
      $(".toggle-menu-button").click(function () {
        $("body").addClass("freeze");
        $(".mcd-left-panel").animate({ left: 0 });
        $(".col-left-nav").addClass("mcd-visible mcd-animate");
      });
      $(".side-nav.close-button").click(function () {
        $(".mcd-left-panel").animate(
          { left: "-300px" },
          {
            duration: 600,
            complete: function () {
              $(".col-left-nav").removeClass("mcd-animate");
              $(".col-left-nav").removeClass("mcd-visible ");
              $("body").removeClass("freeze");
            },
          },
        );
      });
      $(".mcd-nav-list li a").click(function () {
        $(".side-nav.close-button").trigger("click");
      });
    });
  }
  RedirectToFaq() {
    this.route.navigate(["/faq"]);
  }

  resetFilteration(route: string) {
    if (this.previousRoute != route) {
      let existCountryId;
      this.standardService.allStandardsFiltration = new FilterList();
      this.standardService.grsFiltration = new FilterList();
      this.standardService.minimumStandardFiltration = new FilterList();
      this.standardService.sharedLearingsFiltration = new FilterList();
      this.standardService.equipmentStandardFiltration = new FilterList();
      this.standardService.obsoleteStandardFiltration = new FilterList();
      this.standardService.locationGrsFiltration = new FilterList();
      this.standardService.upcomingStandardFiltration = new FilterList();
      this.standardService.operationsStandardFiltration = new FilterList();

      existCountryId =
        this.standardService.nationalEquipmentStandardFiltration.countryId;
      this.standardService.nationalEquipmentStandardFiltration =
        new FilterList();
      this.standardService.nationalEquipmentStandardFiltration.countryId =
        existCountryId;

      existCountryId = this.standardService.nrbesFiltrations.countryId;
      this.standardService.nrbesFiltrations = new FilterList();
      this.standardService.nrbesFiltrations.countryId = existCountryId;

      existCountryId =
        this.standardService.equipmentAddendumFiltration.countryId;
      this.standardService.equipmentAddendumFiltration = new FilterList();
      this.standardService.equipmentAddendumFiltration.countryId =
        existCountryId;

      existCountryId = this.standardService.addendumFiltration.countryId;
      this.standardService.addendumFiltration = new FilterList();
      this.standardService.addendumFiltration.countryId = existCountryId;

      this.standardService.isComingFromLocation = false;
      this.standardService.isGrs = false;
      this.standardService.locationId = 0;
    }
    this.previousRoute = route;
  }
  RedirectToKeycontact() {
    this.route.navigate(["/keycontact"]);
  }

  redirectToAddNrbes() {
    this.route.navigate(["/add-nrbes"]);
  }

  redirectToAddABU() {
    this.route.navigate(["/add-abustandard"]);
  }

  getUsefulLinks(): void {
    this.adminService.GetUsefulLinkList().subscribe((data: UsefulLinkList) => {
      this.usefulLinkList.usefullinks = data.usefullinks.map(
        (o) => new UsefulLink(o),
      );
    });
  }

  onDownloadSelectedUsefulLinkAttachment(e) {
    //debugger;
    return this.adminService.GetAttachmentUrl(e.attachment.id, false).subscribe(
      (response: any) => {
        const blob = new Blob([response], {
          type: response.type,
        });
        if (
          (window.navigator as any) &&
          (window.navigator as any).msSaveOrOpenBlob
        ) {
          (window.navigator as any).msSaveOrOpenBlob(
            blob,
            e.attachment.fileName,
          );
          return;
        }
        var a = document.createElement("a");
        document.body.appendChild(a);

        let url = window.URL.createObjectURL(blob);

        a.href = url;
        a.download = e.attachment.fileName;
        a.click();
        window.URL.revokeObjectURL(url);

        //window.open(url);
      },
      (error: any) => {
        const modalRef = this.ngbModal.open(FailModuleComponent);
        modalRef.componentInstance.errorMessage = error.error
          ? error.error.Message
          : error.message;
      },
    );
  }
}
